import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M14.708 8.25h3.254A8.994 8.994 0 0 0 10.636.156c2.27 1.521 3.87 4.542 4.072 8.094zM9.75 1.344V8.25h3.456c-.195-3.086-1.552-5.688-3.456-6.906zM9.75 9.75v6.906c1.904-1.218 3.261-3.821 3.456-6.906H9.75zM8.25.038A8.991 8.991 0 0 0 .038 8.25h5.151l-2.22-2.22L3 6h2.06l3 3-3 3H3l-.031-.03 2.22-2.22H.038a8.992 8.992 0 0 0 8.212 8.212V.038zM4 5l.03-.03.03.03H4zm.03 8.03L4 13h.06l-.03.03zM14.708 9.75c-.202 3.552-1.802 6.573-4.072 8.094a8.994 8.994 0 0 0 7.326-8.094h-3.254z" />
  </svg>
);

export default SvgComponent;
